// Environment variables configuration
export const OWNER_EMAIL = process.env.REACT_APP_OWNER_EMAIL || "nejirazukicweb18@gmail.com";
export const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

// Telegram configuration (optional)
export const TELEGRAM_BOT_TOKEN = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
export const TELEGRAM_CHAT_ID = process.env.REACT_APP_TELEGRAM_CHAT_ID;
